const styles = theme => ({
  dialogPaper: {
    width: "100%",
    maxWidth: 800,
  },
  dialogContent: {
    padding: theme.spacing(2),
    paddingTop: [theme.spacing(2), "!important"],
  },
  dialogActions: {
    padding: theme.spacing(2),
    paddingTop: 0,
    margin: 0,
  },
  dialogActionsAction: {
    margin: 0,
  },
  headlineWrapper: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  headline: {
    opacity: 0.6,
    fontSize: "1em",
    display: "inline",
  },
  logoWrapper: {
    width: "100%",
    paddingTop: "100%",
    position: "relative",
    "&:hover $addImageOverlay": {
      opacity: 1,
    },
  },
  addPhotoIcon: {
    color: "#fff",
    width: "1.6em",
    height: "1.6em",
  },
  logoImage: {
    width: "100%",
    top: 0,
    left: 0,
    position: "absolute",
    borderRadius: 0,
    fontSize: "4em",
    fontFamily: '"Oswald"',
    backgroundColor: theme.palette.secondary.main,
  },
  logo: {
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    position: "absolute",
    borderRadius: 0,
    fontSize: "4em",
    fontFamily: '"Oswald"',
    backgroundColor: theme.palette.secondary.main,
  },
  logoUploadOverlay: {
    position: "absolute",
    top: "0",
    left: "0",
    zIndex: "1",
    backgroundColor: theme.palette.action.active,
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    cursor: "wait",
  },
  addImageOverlay: {
    position: "absolute",
    top: "0",
    left: "0",
    zIndex: "1",
    backgroundColor: theme.palette.action.disabled,
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    cursor: "pointer",
    opacity: 0,
    transition: theme.transitions.create("opacity", {
      easing: theme.transitions.easing.easeInOut,
    }),
  },
  logoPaper: {
    position: "relative",
  },
  logoLabel: {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    cursor: "pointer",
  },
  logoInput: {
    opacity: 0,
    outline: "none",
  },
  saveAndCloseButton: {
    marginLeft: theme.spacing(1),
  },
  inputWithAddButton: {
    display: "flex",
    padding: `${theme.spacing(1)}px 0`,
  },
  newInputWrapper: {
    flexGrow: 1,
    marginRight: theme.spacing(1),
  },
  organizer: {
    display: "flex",
    borderBottom: "1px solid #9c9c9c",
    paddingBottom: 12,
    "&:not(:first-child)": {
      paddingTop: 12,
    },
    "&:last-of-type": {
      borderBottom: "none",
    },
  },
  organizerContent: {
    flexGrow: "1",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  organizerAvatar: {
    alignSelf: "center",
  },
})

export default styles
